import SectionHeading from "@/components/shared/SectionHeading";
import { FRAMEWORK_STEPS, FRAMEWORK_INTRO } from "@/data/mockData";

export default function FrameworkTimeline({ withHeading = true }) {
  return (
    <section
      data-testid="framework-timeline"
      className="section-pad bg-cream relative"
    >
      <div className="container-page">
        {withHeading && (
          <SectionHeading
            eyebrow={`The ${FRAMEWORK_INTRO.acronym} Framework`}
            title={
              <>
                Your home isn't just where you live — <span className="italic text-bronze">it's how you build the life you want.</span>
              </>
            }
            sub={FRAMEWORK_INTRO.body}
          />
        )}

        {/* Acronym banner */}
        <div className="mt-12 md:mt-16 grid grid-cols-5 gap-3 md:gap-5 border-y border-bronze/25 py-8">
          {FRAMEWORK_STEPS.map((s) => (
            <div key={s.n} className="text-center">
              <div className="font-serif text-5xl md:text-7xl text-bronze leading-none">
                {s.n}
              </div>
              <div className="mt-2 text-[0.6rem] md:text-[0.7rem] tracking-[0.22em] uppercase text-olive">
                {s.label}
              </div>
            </div>
          ))}
        </div>

        {/* Steps timeline */}
        <div className="relative mt-16 md:mt-20">
          <span
            aria-hidden
            className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-bronze/30"
          />
          <div className="space-y-12 md:space-y-20">
            {FRAMEWORK_STEPS.map((s, i) => {
              const isRight = i % 2 === 0;
              return (
                <div
                  key={s.n}
                  data-testid={`framework-step-${s.n}`}
                  className={`reveal grid md:grid-cols-2 gap-6 md:gap-12 items-center ${
                    isRight ? "" : "md:[&>*:first-child]:order-2"
                  }`}
                >
                  {/* letter + label */}
                  <div className={`relative ${isRight ? "md:text-right md:pr-12" : "md:pl-12"}`}>
                    <div className="font-serif text-8xl md:text-9xl text-taupe/40 leading-none">
                      {s.n}
                    </div>
                    <div className="mt-3 text-[0.7rem] md:text-xs tracking-[0.28em] uppercase text-bronze">
                      {s.label}
                    </div>
                    <span
                      aria-hidden
                      className="hidden md:block absolute top-1/2 -translate-y-1/2 h-3 w-3 rounded-full bg-bronze"
                      style={isRight ? { right: "-7px" } : { left: "-7px" }}
                    />
                  </div>
                  {/* content */}
                  <div className={isRight ? "md:pl-12" : "md:pr-12 md:text-right"}>
                    <h3 className="font-serif text-3xl md:text-4xl text-ink leading-tight">
                      {s.title}
                    </h3>
                    <p className="mt-4 text-base md:text-lg font-light text-ink_soft/80 leading-relaxed max-w-md">
                      {s.body}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
